import Permissions from '@app/src/auth/permissions'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './LegacyMenuWrapper'
import { MenuLinkWrapper } from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const SustainabilityProfileLink: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()
  const { sustainabilityProfile } = useFlags()

  if (!sustainabilityProfile) return null

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.transparencySustainabilityProfile,
    permission: Permissions.TRANSPARENCY_USER,
  }

  return (
    <MenuLinkWrapper
      closeMenuDrawer={closeMenuDrawer}
      menuItems={menuItems}
      title={formatMessage({ id: 'navbar.sustainabilityProfile' })}
    />
  )
}

export default SustainabilityProfileLink
